import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import { TRANSLATE_PREFIX } from '../../consts';
import RequiredInput from '../RequiredInput';
import css from './FieldNameCell.css';

const TAB_PREFIX = `${TRANSLATE_PREFIX}.TRACKING_LINK_OPTIONS_TAB`;
const paramT = key => `${TAB_PREFIX}.PARAMS.${key.toUpperCase()}`;

const FieldNameCell = ({ row, setParam, readOnly, translate }) => {
    const { isCustomRow, index, singular_key: singularKey, field_name: fieldName, isRequired } = row;
    if (isCustomRow) {
        return (
            <td>
                <RequiredInput
                    value={fieldName}
                    placeholder={readOnly ? undefined : translate(`${TAB_PREFIX}.CUSTOM_FIELD_NAME_PLACEHOLDER`)}
                    onChange={val => setParam(index, 'field_name', val)}
                    disabled={readOnly}
                />
            </td>
        );
    }
    return (
        <td>
            <span className={css.fieldName}>
                <Translate id={`${paramT(singularKey)}.FIELD_NAME`} />
                {!readOnly && isRequired && <span className={css.required}>*</span>}
            </span>
        </td>
    );
};

FieldNameCell.propTypes = {
    row: PropTypes.shape({
        isCustomRow: PropTypes.bool.isRequired,
        index: PropTypes.number.isRequired,
        singular_key: PropTypes.string,
        field_name: PropTypes.string,
        isRequired: PropTypes.bool,
    }).isRequired,
    setParam: PropTypes.func.isRequired,
    readOnly: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

export default FieldNameCell;
